import { render, staticRenderFns } from "./ports.vue?vue&type=template&id=43474c45"
import script from "./ports.vue?vue&type=script&lang=js"
export * from "./ports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports